import { render, staticRenderFns } from "./HouseCard.vue?vue&type=template&id=1a1d1406&scoped=true"
import script from "./HouseCard.vue?vue&type=script&lang=js"
export * from "./HouseCard.vue?vue&type=script&lang=js"
import style0 from "./HouseCard.vue?vue&type=style&index=0&id=1a1d1406&prod&scoped=true&lang=css"
import style1 from "./HouseCard.vue?vue&type=style&index=1&id=1a1d1406&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d1406",
  null
  
)

export default component.exports